/** Nested-modal safe: keep the page (`.content-area`) from scrolling under a dialog. */
let lockCount = 0;

export function lockBodyScroll(): () => void {
  lockCount += 1;
  document.body.classList.add('modal-open');
  return () => {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      document.body.classList.remove('modal-open');
    }
  };
}

/** Stop wheel/touch from chaining into `.content-area` (overlay is a descendant of it). */
export function stopScrollChain(e: { stopPropagation: () => void }): void {
  e.stopPropagation();
}
